import { alpha, Theme } from "@mui/material";
import { useBanner } from "src/contexts/BannerContext";

// ----------------------------------------------------------------------

export default function Drawer(theme: Theme) {
  const isLight = theme.palette.mode === "light";
  const { visible } = useBanner();

  return {
    MuiDrawer: {
      styleOverrides: {
        modal: {
          '&[role="presentation"]': {
            "& .MuiDrawer-paperAnchorLeft": {
              boxShadow: `8px 24px 24px 12px ${alpha(
                theme.palette.grey[900],
                isLight ? 0.16 : 0.48
              )}`,
              top: "var(--banner-height, 0px)", // 👈 dynamic based on banner
              height: "calc(100% - var(--banner-height, 0px))", // 👈 adjust height
              transition: "top 0.3s ease, height 0.3s ease",
            },
            "& .MuiDrawer-paperAnchorRight": {
              boxShadow: `-8px 24px 24px 12px ${alpha(
                theme.palette.grey[900],
                isLight ? 0.16 : 0.48
              )}`,
              top: "var(--banner-height, 0px)", // 👈 dynamic based on banner
              height: "calc(100% - var(--banner-height, 0px))", // 👈 adjust height
              transition: "top 0.3s ease, height 0.3s ease",
            },
          },
        },
      },
    },
  };
}
